import { useNavigate } from 'react-router-dom';
import { FileText, ArrowLeft } from 'lucide-react';
import { useLanguage } from '@/context/LanguageContext';
import { useTranslation } from '@/utils/i18n';

function Terms() {
  const navigate = useNavigate();
  const { language } = useLanguage();
  const { t } = useTranslation(language);

  return (
    <div className="min-h-screen bg-[#0a0a0a] text-white">
      <div className="max-w-4xl mx-auto px-6 py-12">
        <button
          onClick={() => navigate('/')}
          className="flex items-center gap-2 text-gray-400 hover:text-[#ff6b35] transition-colors mb-8"
        >
          <ArrowLeft className="w-5 h-5" />
          {t('backToHome')}
        </button>

        <div className="flex items-center gap-3 mb-6">
          <FileText className="w-8 h-8 text-[#ff6b35]" />
          <h1 className="text-4xl font-bold gradient-text">{t('termsConditions')}</h1>
        </div>

        <div className="bg-[#1a1a1a] border border-[#ff6b35]/20 rounded-xl p-8 space-y-6">
          <div className="space-y-6 text-gray-300 leading-relaxed">
            <div>
              <h2 className="text-xl font-semibold text-white mb-3">{t('termsTitle')}</h2>
              <ol className="list-decimal list-inside space-y-3">
                <li>{t('term1')}</li>
                <li><strong>{t('term2')}</strong></li>
                <li>{t('term3')}</li>
                <li>{t('term4')}</li>
                <li>{t('term5')}</li>
                <li>{t('term6')}</li>
                <li>
                  {t('term7')}
                  <ul className="list-disc list-inside ml-6 mt-2 space-y-1">
                    <li>{t('termDisclaimer')}</li>
                    <li>{t('termPrivacy')}</li>
                    <li>{t('termRefund')}</li>
                    <li>{t('termSubscription')}</li>
                  </ul>
                </li>
              </ol>
            </div>

            <div className="bg-[#ff6b35]/10 border border-[#ff6b35]/30 rounded-lg p-6 mt-6">
              <p className="font-semibold text-[#ff6b35] mb-3">{t('termResponsibility')}</p>
              <div className="border-t border-[#ff6b35]/20 pt-3 mt-3 space-y-1 text-sm text-gray-400">
                <p><span className="text-orange-400 font-semibold">Do Not Bull</span> {language === 'fr' ? 'est une marque de' : language === 'es' ? 'es una marca de' : 'is a brand of'} <span className="text-white font-semibold">Strategy Intelligence Solutions LTD</span></p>
                <p>{language === 'fr' ? 'Enregistrée en Angleterre et au Pays de Galles' : 'Registered in England & Wales'} — Company No. 16760736</p>
                <p>128 City Road, London EC1V 2NX, United Kingdom</p>
              </div>
            </div>
          </div>

          <div className="pt-6 border-t border-gray-800">
            <p className="text-sm text-gray-400">
              {t('lastUpdated')} {new Date().toLocaleDateString(language === 'fr' ? 'fr-FR' : language === 'es' ? 'es-ES' : 'en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Terms;